export default __webpack_public_path__ + "21c75b34a2364f2e7a1f3af3cb639a3b.png";